import "htmx.org";
import * as bootstrap from "bootstrap";
import "./toasts";
import "./data_list_field";
import "./text_templates";

window.htmx = require("htmx.org");
